import axios from 'axios';

// Determine API base URL based on environment
// If running locally (even with production build), use localhost
// If deployed to Azure or custom domain, use same origin
const getApiBaseUrl = () => {
  // Check if we're running on localhost (testing production build locally)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // In production (Azure deployment), use the same origin (empty string works best)
  // This ensures the frontend calls the backend on the same domain
  return '';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Public API
export const couponApi = {
  // Get all active coupons (with optional filters)
  getCoupons: (params) => api.get('/api/coupons', { params }),
};

// Newsletter API
export const newsletterApi = {
  // Subscribe to newsletter
  subscribe: (email) => api.post('/api/newsletter/subscribe', { email }),
};

// Admin API
export const adminApi = {
  // Login
  login: (credentials) => api.post('/api/admin/login', credentials),
  
  // Get all coupons (including expired)
  getAllCoupons: () => api.get('/api/admin/coupons'),
  
  // Create coupon
  createCoupon: (couponData) => api.post('/api/admin/coupons', couponData),
  
  // Update coupon
  updateCoupon: (id, couponData) => api.put(`/api/admin/coupons/${id}`, couponData),
  
  // Delete coupon
  deleteCoupon: (id) => api.delete(`/api/admin/coupons/${id}`)
};

export default api;
